import { connect } from 'react-redux';
import React, { Component } from 'react';
import routerActions from 'app/routerActions';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { Field, FieldArray, formValueSelector, reduxForm } from 'redux-form';
import * as valid from 'utils/validate';
import { subscriptionActions } from 'app/actions';
import { api, apiUtils } from 'app/services';
import {
KBFormError,
KBButton,
KBPopover,
KBPopoverTop,
KBCheckBox } from
'components';
import { getSpaceVirtualCurrencyName } from 'app/selectors';
import * as constants from 'app/constants';
import SpaceAddMemberShipDiscountForm from './SpaceAddMemberShipDiscountForm';
import { renderKBInput, toKBArrayField } from 'components/formAdapters/reduxFormAdapters';

var SpaceAddMemberShipBookingForm = class extends React.Component {constructor(props) {super(props);this.state = this.getInitialState();this.parseDiscountForm = this.parseDiscountForm.bind(this);this.updateDiscounts = this.updateDiscounts.bind(this);this.addDiscounts = this.addDiscounts.bind(this);this.changeAllowExtraPurchaseStatus = this.changeAllowExtraPurchaseStatus.bind(this);}getInitialState()
  {
    return {
      isLoading: false,
      allowExtraPurchase: false };

  }parseDiscountForm(
  model) {
    const { callback } = this.props;
    this.setState({
      isLoading: true });

    callback && callback(model);
    KBPopover.close();
  }componentWillUnmount()

  {
    this.setState({
      isLoading: false });

  }updateDiscounts(
  model) {
    model.price = this.props.currentPrice || '0';
    this.discountsFields && this.discountsFields.addField(model);
  }addDiscounts()
  {
    KBPopoverTop.show(
    <SpaceAddMemberShipDiscountForm
    quota_type="booking"
    isTop={true}
    callback={this.updateDiscounts} />);


  }changeAllowExtraPurchaseStatus(

  status) {
    this.setState({
      allowExtraPurchase: status });

  }render()

  {
    const {
      error,
      submitting,
      handleSubmit,
      virtual_currency_name } =
    this.props;
    const { isLoading, allowExtraPurchase } = this.state;
    const oneClass = {
      className: 'kb-form-group kb-form-210 kb-form-alone' };

    return (
      <form onSubmit={handleSubmit(this.parseDiscountForm)}>
        <KBFormError error={this.props.error} />
        <div className="kb-form-header">
          <h2 className="header-title">添加会议室额度</h2>
          <i
          className="iconfont header-close icon-cancel"
          onClick={KBPopover.close} />

        </div>
        <div className="kb-form-container">
          {/* <div className='kb-row'>
             <KBInput title={`${virtual_currency_name}购买`} isRequired = {true} label='true' placeholder={`用多少${virtual_currency_name}购买，默认是价格*100`} className = 'kb-form-group kb-form-c18 kb-form-alone' field={ point } value={ point.value } />
            </div> */}
          <div className="kb-row">
            <Field
            name="available_credits"
            component={renderKBInput}
            title="使用小时数"
            type="number"
            isRequired={true}
            label="true"
            hint="输入该会员类型包含的工位免费会议室使用小时数"
            className="kb-form-group kb-form-210 kb-form-alone"
            inputClass="input-hour" />

          </div>
          <div className="kb-row">
            <div className="kb-form-group kb-form-210 kb-form-alone">
              <label>额外购买</label>
              <div>
                <div style={{ display: 'flex', paddingTop: 9 }}>
                  <div className="d-iblock">
                    <KBCheckBox
                    checked={allowExtraPurchase}
                    callback={this.changeAllowExtraPurchaseStatus} />

                  </div>
                  <span style={{ marginLeft: 5, verticalAlign: 'middle' }}>
                    允许额外购买更多使用小时数
                  </span>
                </div>
                {allowExtraPurchase ?
                <div className="kb-row kb-form-66">
                    <Field
                  name="price"
                  component={renderKBInput}
                  title="价格"
                  type="number"
                  isRequired={true}
                  label="true"
                  placeholder="¥"
                  className="kb-form-group kb-form-c39 kb-form-alone"
                  inputClass="input-per-hour" />

                  </div> :
                null}
                {allowExtraPurchase ?
                <div className="kb-row">
                    <div className="kb-form-group kb-form-c18 kb-form-alone">
                      <label>优惠</label>
                      <div>
                        <FieldArray name="discounts"
component={({ fields }) => {
                            const discounts = toKBArrayField(fields);
                            this.discountsFields = discounts;
                            return discounts.map((discount, index) => {
                        return (
                          <div style={{ paddingTop: 9 }}>
                              <span>
                                满&nbsp;{discount.number.value || 0}
                                &nbsp;赠&nbsp;
                                {discount.complimentary_number.value || 0}
                              </span>
                              <a
                            className="color-link m-left-sm"
                            style={{ cursor: 'pointer' }}
                            onClick={e => {
                              discounts.removeField(index);
                            }}>

                                删除
                              </a>
                            </div>);

                      });
                          }} />
                        <div style={{ paddingTop: 9 }}>
                          <a
                        className="color-link"
                        style={{ cursor: 'pointer' }}
                        onClick={this.addDiscounts}>

                            添加优惠
                          </a>
                        </div>
                      </div>
                    </div>
                  </div> :
                null}
              </div>
            </div>
          </div>
          {/* <fieldset className='fieldset'>
             <legend>优惠信息</legend>
             <table className='content-table' style={{tableLayout : 'fixed', marginTop: 0}}>
               <thead>
                 <tr>
                   <th>购买满多少</th>
                   <th>价格</th>
                   <th>{ virtual_currency_name }</th>
                   <th>赠送数量</th>
                   <th>可获得的{ virtual_currency_name }</th>
                 </tr>
               </thead>
               <tbody>
                 {
                   discounts.map(discount => {
                     return (
                       <tr>
                         <td>{ discount.number.value }</td>
                         <td>{ discount.price.value }</td>
                         <td>{ discount.point.value }</td>
                         <td>{ discount.complimentary_number.value }</td>
                         <td>{ discount.point.value }</td>
                       </tr>
                     )
                   })
                 }
               </tbody>
             </table>
             <button className="certain-btn m-top-sm" type='button' onClick={ this.addDiscounts }>添加</button>
            </fieldset> */}
          <div className="f-right">
            <span className="cancel-btn" onClick={KBPopover.close}>
              取消
            </span>
            <button className="certain-btn m-left-sm" type="submit">
              {isLoading ? '加载中...' : '确定'}
            </button>
          </div>
        </div>
      </form>);

  }};


function mapStateToProps(state, props) {
  let virtual_currency_name = getSpaceVirtualCurrencyName(state);
  const selector = formValueSelector('SpaceAddMemberShipBookingForm');
  return {
    currentPrice: selector(state, 'price'),
    virtual_currency_name,
    initialValues: {
      // recurring_amount  : parseFloat(total).toFixed(2) || 0,
      // start_date,
      // end_date,
      // recurring_cycles  : 1,
      // recurring_due_day : 31
    } };

}

function mapDispatchToProps(dispatch) {
  return {};
}

const validate = values => {
  const errors = {};

  // if (valid.isPrice(values.recurring_amount)) {
  //   errors.recurring_amount = '请输入正确的价格, 小数点保留2位'
  // }

  return errors;
};

const formConfig = {
  form: 'SpaceAddMemberShipBookingForm',
  touchOnBlur: false,
  validate: validate };


export default connect(mapStateToProps, mapDispatchToProps)(reduxForm(formConfig)(SpaceAddMemberShipBookingForm));
